export const reports = {
  date: "Date",
  month: "Month",
  cancel: "Cancel",
  download: "Download",
  export: "Export",
  selectPeriod: "Select period",
  selectPayouts: "Select payout periods",
  dropdownLabel: "Date: {{selected}}",
  salesByProductReport: {
    title: "Sales by product report",
    description:
      "A monthly breakdown of product sales to help you understand the purchasing behaviour of your {{patientTermPlural}}.",
  },
};
